import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ActionCreator from './../store/actions/index';
import CarsTopBar from "../components/CarComponents/TopBar/CarsTopBar";
import CarsTable from "../components/CarComponents/Table/CarsTable";
import PaperContainer from '../components/Common/PaperContainer';

const CarsView = (props) => {

    const {cars, setSearchField} = props;

    const [filtered, setFiltered] = useState([]);

    const handleFilterData = (data) => {
        const temp = JSON.stringify([...data]);
        const newArray = JSON.parse(temp);
        setFiltered(newArray);
    };

    return (
        <React.Fragment>
            <CarsTopBar
                data={filtered}
            />
            <PaperContainer>
                <CarsTable
                    cars={cars}
                    onSelectedRegistrationNo={(registrationNo) => setSearchField(registrationNo)}
                    onFilter={handleFilterData}
                />
            </PaperContainer>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    cars: state.carsReducer.cars
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

CarsView.propTypes = {
    //redux
    cars: PropTypes.array,
    setCars: PropTypes.func,
    setSearchField: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CarsView);
